module.exports = __webpack_public_path__ + "img/menu-burger-alb.77fa3bc5.svg";